module.exports = __webpack_public_path__ + "img/jft_red_tit.fc98247c.png";